<template>
  <div class="mapTable">
    <div class="title">
      <img src="@/img/datav/title_icon.png" alt="" />
      <span>{{ item.districtName }}</span>
    </div>
    <div id="content" class="content" @scroll="onScroll">
      <div class="data-table">
        <table>
          <!-- 第一行 -->
          <tr class="header">
            <td width="170px">经营收入（万元）</td>
            <td width="170px">经营利润（万元）</td>
            <td width="250px">带动村集体经济增收（万元)</td>
            <td>耕地综合利用亩数</td>
            <td>其中撂荒地亩数</td>
          </tr>
          <tr class="data">
            <td @click="showDetail(1)">{{ item.operatingIncome }}</td>
            <td @click="showDetail(2)">{{ item.operatingProfit }}</td>
            <td @click="showDetail(3)">{{ item.villageCollectiveIncome }}</td>
            <td @click="showDetail(4)">{{ item.landUseArea }}</td>
            <td @click="showDetail(5)">{{ item.abandonedLandArea }}</td>
          </tr>

          <!-- 第二行和第三行 -->
          <tr class="header">
            <td colspan="3" class="merged-header">劳动就业人数</td>
            <td rowspan="2" class="merged-header">主营业务</td>
            <td rowspan="2" class="merged-header">营收占比</td>
          </tr>
          <tr class="header sub-header">
            <td>一般户（人）</td>
            <td>脱贫户（人）</td>
            <td>发放工资总额（万元）</td>
          </tr>

          <!-- 最后一行数据 -->
          <tr class="data">
            <td @click="showDetail(6)">{{ item.generalPopulation }}</td>
            <td @click="showDetail(7)">{{ item.povertyPopulation }}</td>
            <td @click="showDetail(8)">{{ item.laborRemuneration }}</td>
            <td>{{ item.business }}</td>
            <td>{{ item.revenue }}</td>
          </tr>
        </table>
      </div>
      <div id="compantList" class="company-list">
        <div
          v-for="c in item.companyList"
          :key="c.id"
          class="company-item one-line"
          @click="toCompanyDetail(c)"
        >
          {{ c.companyName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      colData: [
        { name: '经营收入（万元）', key: 'operatingIncome' },
        { name: '经营利润（万元）', key: 'operatingProfit' },
        { name: '带动村集体增收（万元）', key: 'villageCollectiveIncome' },
        { name: '耕地综合利用亩数', key: 'landUseArea' },
        { name: '其中撂荒地亩数', key: 'abandonedLandArea' },
        { name: '一般户（人）', key: 'generalPopulation' },
        { name: '脱贫户（人）', key: 'povertyPopulation' },
        { name: '发放工资总额（万元）', key: 'laborRemuneration' },
      ],
      lastScrollTop: 0,
    }
  },
  methods: {
    showDetail(key) {
      this.$emit('show', { col: this.colData[key - 1], data: this.item })
      // this.$refs.TableDetail.show()
    },
    toCompanyDetail(item) {
      this.$emit('showCompanyDetail', { id: item.id, companyName: item.companyName })
    },
    onScroll(e) {
      console.log(e)
      const scrollTop = e.target.scrollTop
      if (this.lastScrollTop == 0 && scrollTop > this.lastScrollTop) {
        const elementTop = document.getElementById('compantList').offsetTop
        const content = document.getElementById('content')
        content.scrollTo({ top: elementTop })
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    },
  },
}
</script>

<style lang="scss" scoped>
.company-list {
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  gap: 16px 24px;

  .company-item {
    flex: 0 0 calc((100% - 48px) / 3);
    min-width: 260px;
    border: 1px solid rgba(0, 192, 254, 0.3);
    padding: 12px 16px;
    font-size: 18px;
    color: #e0eafa;
    cursor: pointer;
    background: linear-gradient(135deg, rgba(0, 192, 254, 0.08) 0%, rgba(5, 13, 76, 0.4) 100%);
    transition: all 0.3s ease;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 3px;
      height: 100%;
      background: linear-gradient(180deg, #00c0fe 0%, #0066ff 100%);
      opacity: 0.6;
    }

    &:hover {
      background: linear-gradient(135deg, rgba(0, 192, 254, 0.2) 0%, rgba(5, 13, 76, 0.6) 100%);
      border-color: rgba(0, 192, 254, 0.6);
      color: #66ffff;
      transform: translateX(4px);

      &::before {
        opacity: 1;
      }
    }
  }
}

.mapTable {
  // position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 24px 30px;

  .title {
    width: 550px;
    position: relative;
    font-size: 26px;
    color: #ecf8ff;
    display: flex;
    align-items: center;
    margin-bottom: 26px;

    img {
      margin-right: 3px;
    }
  }
}

.content {
  height: calc(100% - 80px);
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.data-table {
  width: 100%;
  margin: 0 auto;
  font-size: 19px;
  border-radius: 8px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: transparent;
  color: #e0eafa;
  table-layout: fixed;
  font-size: 18px;
  border-radius: 8px;
}

td {
  border: 1px solid rgba(0, 192, 254, 0.25);
  text-align: center;
  padding: 8px 10px;
  vertical-align: middle;
  line-height: 1.4;
  background: rgba(5, 13, 76, 0.6);
}

.header {
  td {
    background: linear-gradient(180deg, rgba(0, 192, 254, 0.25) 0%, rgba(0, 102, 255, 0.15) 100%);
    color: #66ffff;
    font-weight: 500;
    border-color: rgba(0, 192, 254, 0.4);
  }

  .merged-header {
    background: linear-gradient(180deg, rgba(0, 192, 254, 0.4) 0%, rgba(0, 102, 255, 0.25) 100%);
    color: #fff;
    font-weight: 600;
    font-size: 19px;
    border-color: rgba(0, 192, 254, 0.5);
  }
}

.sub-header {
  td {
    background: linear-gradient(180deg, rgba(0, 192, 254, 0.18) 0%, rgba(0, 102, 255, 0.1) 100%);
    color: #a8d8ff;
    font-size: 17px;
    border-color: rgba(0, 192, 254, 0.3);
  }
}

.data {
  td {
    background: rgba(5, 13, 76, 0.4);
    color: #ecf8ff;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
      background: linear-gradient(180deg, rgba(0, 192, 254, 0.2) 0%, rgba(0, 102, 255, 0.1) 100%);
      color: #66ffff;
      border-color: rgba(0, 192, 254, 0.5);
    }
  }
}
</style>
